import { Grid, Skeleton, Stack } from "@mui/material";

const PlainDetailInfoSkeleton = () => {
  return (
    <Stack
      gap={2}
      bgcolor="background.paper"
      p={2}
      borderRadius={2}
      border="1px solid"
      borderColor="divider"
    >
        <Grid container spacing={1.5}>
        {[...Array(5)].map((_, index) => (
          <Grid item xs={12} sm={6} md={2.4} key={index}>
            <Stack
              bgcolor="background.primary01"
              borderRadius={2}
              px={2}
              py={1.5}
              gap={0.2}
              minHeight={88}
            >
              <Skeleton variant="rounded" width={42} height={42} />
              <Skeleton variant="text" width="60%" height={20} />
              <Skeleton variant="text" width="85%" height={20} />
              <Skeleton variant="text" width="55%" height={20} />
            </Stack>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};

export default PlainDetailInfoSkeleton;
